var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',_vm._g(_vm._b({staticClass:"line-button"},'el-button',_vm.$attrs,false),_vm.$listeners),[_c('img',{class:_vm.imgClass,attrs:{"src":_vm.Constants.SHOP_CONFIG.LINE_ICON,"alt":""}}),_c('span',[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }